import tippy from 'tippy.js';

const button = document.querySelector('button.call__button');

const config = {
  arrow: true,
  animation: 'scale-subtle',
  flipOnUpdate: true,
  interactive: true,
  boundary: 'viewport',
  popperOptions: {
    placement: 'auto',
  },
  theme: 'light-border',
  trigger: 'click',
  zIndex: 999999,
};

const tippyInstance = tippy(button, config);

let productDetail;

button.addEventListener('click', () => {
  if (!productDetail) {
    productDetail = document.createElement('div');
    productDetail.classList.add('tippy__callback', 'desktop');
    productDetail.innerHTML = $('.block-phones').html();
    tippyInstance.setContent(productDetail);
    tippyInstance.show();
  }
});
